
import axios from "axios";
import queryString from "query-string";

import { useUser } from "../zustand/store.js";

axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.common["scd"] = "AIARTSSCD";

//axios.defaults.baseURL = consts.apiBaseUrl;

export const post = (url, sender = {}) => {

  const token = useUser.getState().token;

  axios.defaults.headers.common["authorization"] = token;

  // let dm = "http://ew.pnsoft.co.kr:40090"; // PNSOFT TEST SERVER
  let dm = "https://lab-api.aiwith.art"; // LIVE SERVER
  // let dm = "http://localhost:4000"; // local

  // console.log('token', token);
  // console.log('sender', sender);

  return axios.post(dm + `${url}`, sender);
};